<template>
  <div>
    <div class="tabs-list" v-if="list && list.length">
      <van-tabs 
        v-model="listCurrent" 
        line-width="20"
        @change="listTabsChange"
      >
        <van-tab 
          :title="listItem.carType"
          title-style="font-size: 16px;"
          v-for="listItem in list" :key="listItem.id"
        ></van-tab>
      </van-tabs>
    </div>
    <div class="tabs-children-list" v-if="list && list.length">
      <van-tabs 
        type="card" 
        color="#EC892E"
        swipeable
        :ellipsis="false"
        v-model="childrenCurrent" 
      >
        <van-tab 
          :title="childrenItem.beecargoCarTypeName"
          v-for="childrenItem in list[listCurrent].children" :key="childrenItem.id"
        >
          <div style="display: flex;align-items: center;">
            <van-image
              width="162"
              height="108"
              style="margin: 0px 0 0px 0;flex-shrink: 0;margin-left: 5px;"
              :src="childrenItem.carPicture"
              @click="handleImagePreview({ childrenList:list[listCurrent].children , src: childrenItem.carPicture })"
            ></van-image>
            <div style="margin-left: 5px;">
              <div style="display:flex;align-items:center;">
                <div class="parameter">载重：{{ childrenItem.loadRange ? childrenItem.loadRange : "0" }}T</div>
                <div class="parameter-tag" @click="handleCarAttributeDetailsPopup">
                  <span>详情</span>
                  <van-icon name="arrow" size="10px" color="#FFF" />
                </div>
              </div>
              <div class="parameter">长宽高：{{childrenItem.lengthRange}}m*{{childrenItem.wideRange}}m*{{childrenItem.highRange}}m</div>
              <div class="parameter">装载体积：{{childrenItem.cargoVolumeRange}}m³</div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { Tab, Tabs , Image ,Icon } from 'vant';
import { getCarType } from "@/api/driver/cancelOrderRules/index.js";

export default {
  components:{
    [Tab.name]:Tab,
    [Tabs.name]:Tabs,
    [Image.name]:Image,
    [Icon.name]:Icon,
  },
  inject:["imagePreview","carAttributeDetailsPopup"],
  props:["carTypeId"],
  created(){
    this.getList();
  },
  data(){
    return {
      // 车辆属性列表
      list:[],
      listCurrent:0,
      childrenCurrent:0,
    }
  },
  computed:{
    listCurrentAndChildrenCurrent(){
      return `${this.listCurrent}-${this.childrenCurrent}`;
    }
  },
  watch:{
    listCurrentAndChildrenCurrent(val){
      let carTypeId = this.list[this.listCurrent].children[this.childrenCurrent].id;
      this.$emit("update:carTypeId",carTypeId);
    }
  },
  methods:{
    // 预览图片
    handleImagePreview({ childrenList , src }){
      let images = childrenList.map(childrenItem=>childrenItem.carPicture).filter(item=>item);
      this.imagePreview({ images , src });
    },
    getList(){
      return getCarType().then(({ data }) => {
        this.list = data;
        this.$emit("update:carTypeId",this.list[this.listCurrent].children[this.childrenCurrent].id);
        this.$nextTick(()=>{
          this.transLateListChildren();
        })
      })
    },
    // 移动
    transLateListChildren(){
      let tabsDom = document.querySelectorAll(".van-tabs__wrap")[1];
      let contentDom = document.querySelectorAll(".van-tabs__content")[1];
      tabsDom.style.transform = `translateY(${contentDom.offsetHeight+4}px)`;
      contentDom.style.transform = `translateY(-${tabsDom.offsetHeight}px)`;
    },
    listTabsChange(){
      this.childrenCurrent = 0;
    },
    handleCarAttributeDetailsPopup(){
      this.carAttributeDetailsPopup({
        list: this.list
      });
    }
  }
}
</script>

<style scoped lang="scss">
  .tabs-list {
    ::v-deep .van-tabs__wrap {
      height: 39px;
      .van-tabs__line {
        bottom: 18px;
        background-color: #EC892E !important;
      }
      .van-tab--active {
        .van-tab__text {
          color: #EC892E;
          font-weight: bold;
        }
      }
    }
  }
  ::v-deep .tabs-children-list {
    .van-tabs__nav--card {
     border: none;
     .van-tab {
       border: none;
       color: #3D3833 !important;
     }
     .van-tab--active {
       border-radius: 8px;
       color: #FFF !important;
     }
   }
  }
  .parameter {
      font-size: 12px;
      line-height: 28px;
      color: #C9C2BB;
    }
    .parameter-tag {
      width: 45px;
      height: 16px;
      color: #FFF;
      font-size: 10px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      background: linear-gradient(139deg, #FFBD2D 0%, #EC892E 100%);
      text-align: center;
      margin-left: 8px;
      
      span {
        line-height: 16px;
        transform: translate();
      }
    }
</style>